
// One shared, human-readable job counter spanning BOTH the ROI-load phase
// (RoiPointLoader.js, main thread) and the Worker compute phase
// (VolumeJob.js/volumeWorker.js) - task requirement (Fase 7, section 2):
// "Log til console med ét samlet jobId", so a single "[Volume job N]" tag
// can be grepped across the whole pipeline for one measurement attempt.
let counter = 0;

export function nextVolumeJobId(){
	return ++counter;
}
